import { createTranslations } from '@npco/utils-translations'

export const translations = createTranslations({
  categoryTab: 'Category',
  itemsLoading: 'Items',
  itemsTab: 'Items ({itemCount})',
})
